/**
 * Codmonサイドメニュー折りたたみディレクティブ
 *
 * @description
 * このディレクティブは、タイトルクリックで内容を開閉できる折りたたみ式のUIコンポーネントを提供します。
 * 初期状態、開閉時のコールバック機能を持ちます。
 *
 * @example
 * // 基本的な使用方法
 * <codmon-sidemenu-collapsible title="メニューアイテム" default-open="true" on-toggle="handleToggle(isOpen)">
 *   <p>ここに折りたたまれるコンテンツを配置</p>
 * </codmon-sidemenu-collapsible>
 *
 * @example
 * // デフォルトで閉じた状態
 * <codmon-sidemenu-collapsible title="サブメニュー">
 *   <ul>
 *     <li>項目1</li>
 *     <li>項目2</li>
 *   </ul>
 * </codmon-sidemenu-collapsible>
 *
 * @property {string} title - 折りたたみのタイトルテキスト
 * @property {boolean} [defaultOpen=false] - 初期表示時の開閉状態
 * @property {Function} [onToggle] - 開閉状態が変化した時のコールバック関数（isOpen: booleanを受け取る）
 */
angular.module('inspinia').directive('codmonSidemenuCollapsible', () => {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      label: '@',
      defaultOpen: '=',
      onToggle: '&',
    },
    templateUrl: `/manage/src/view/directive/codmon-ui/codmon_sidemenu_collapsible.html?${new Date().getTime()}`,
    link($scope) {
      $scope.isOpen = $scope.defaultOpen;

      // 初期表示時にデフォルトOpenの場合のみアニメーション無効化
      $scope.isInitializing = $scope.defaultOpen;

      $scope.toggle = () => {
        $scope.isOpen = !$scope.isOpen;
        // 初回クリック以降はアニメーションを有効化
        if ($scope.isInitializing) {
          $scope.isInitializing = false;
        }
        if ($scope.onToggle) {
          $scope.onToggle({ isOpen: $scope.isOpen });
        }
      };
    },
  };
});
